import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { userContext } from "../../context/user";
import { useUser } from "../../api/queries/user/useUser";

export default function Homepage() {
  const navigate = useNavigate();
  const { detail } = useContext(userContext);
  const { data: user } = useUser(detail?.id);
  const {
    isPeopleEditor,
    isAccountManager,
    isProfileManager,
    isProfileManagerTemp,
  } = useContext(userContext);

  useEffect(() => {
    if (user) {
      if (user.data.placement_environments.length > 0) {
        navigate(
          `/journey-trackers/${user.data.placement_environments[0].results.placement_environment.id}`,
        );
      } else if (
        isPeopleEditor() ||
        isAccountManager() ||
        isProfileManager() ||
        isProfileManagerTemp()
      ) {
        navigate("/people");
      } else {
        navigate("/journey-trackers/new");
      }
    }
  }, [
    navigate,
    user,
    isPeopleEditor,
    isAccountManager,
    isProfileManager,
    isProfileManagerTemp,
  ]);

  return <></>;
}
